import React, { createContext, useState, useContext, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';

const VacationContext = createContext();

export function VacationProvider({ children }) {
  const [vacationMode, setVacationMode] = useState(null);

  useEffect(() => {
    const db = getDatabase();
    const vacationRef = ref(db, 'vacation');
    
    const unsubscribe = onValue(vacationRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.active) {
        try {
          const startDate = new Date(data.startDate);
          const endDate = new Date(data.endDate);
          
          if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
            setVacationMode({
              startDate,
              endDate,
              active: true
            });
          } else {
            console.error('Invalid vacation dates');
            setVacationMode(null);
          }
        } catch (error) {
          console.error('Error parsing vacation dates:', error);
          setVacationMode(null);
        }
      } else {
        setVacationMode(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <VacationContext.Provider value={vacationMode}>
      {children}
    </VacationContext.Provider>
  );
}

export function useVacation() {
  const context = useContext(VacationContext);
  if (context === undefined) {
    throw new Error('useVacation must be used within a VacationProvider');
  }
  return context;
}
